import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-sm-plain-text',
  templateUrl: './sm-plain-text.component.html',
  styleUrls: ['./sm-plain-text.component.scss'],
})
export class SmPlainTextComponent  implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit() {}

}
